

export default function Section5() {
  return (

    <section class="digital-marketing-section py-8 md:py-10 bg-[#F5F5F5]">
  <div class="container-1280 section5-container  mx-auto w-full px-[15px] md:w-[750px] lg:w-[970px] xl:w-[100%]">
    <div class="heading text-center max-w-4xl mx-auto">
      <h1 class="text-[24px] md:text-4xl font-bold mb-4 leading-normal">Expert Digital Marketing Services in Dubai</h1>
      <p class="text-[16px] font-open text-[#373737] mt-0 lg:mt-0 mb-5">
        At Mean3, we provide digital marketing services in Dubai. Our goal is to help businesses
        grow online with strategic and measurable solutions. We are a dependable digital marketing
        agency. Our goal is to raise visibility, generate traffic, and convert leads into loyal customers.
        We offer 
        <a href="https://mean3.com/seo/" class="font-[400] text-[#000]"> SEO</a>, 
        <a href="https://mean3.com/performance-marketing/" class="font-[400] text-[#000]"> PPC</a>, 
        <a href="https://mean3.com/digital-marketing/" class="font-[400] text-[#000]"> social media marketing</a>, 
        content creation, email campaigns, and website optimization. All our services are designed to fit your 
        business goals. Every strategy is customized to ensure you get maximum value from your investment.
      </p>
    </div>
  </div>
  
</section>

    
  );
}